module.exports = __webpack_public_path__ + "h5/img/global_hg.3386150f.png";